<template>
  <div class="w-100 mt-5">
    <div class="row">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-12 col-xl-12 fw-bold">
            Orders Fee Setting
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-12 col-lg-12 col-xl-12 fw-bold">
          <table class="table" id="myTable">
            <tbody id="tBody">
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td class="tdBottomless">
                  <div class="label">
                    <span>
                      Paxel Default Commission
                    </span>
                    <img alt="info" class="info-icon" src="@/assets/ic_info.png" @click="handleShow('commission')"/>
                  </div>
                </td>
                <td class="tdBottomless">          
                  <div class="input-group">
                    <input 
                      type="number" 
                      class="form-control fw-bold" 
                      v-model="default_comission"
                      @keydown="isNumber()"
                      placeholder="0" 
                      style="text-align:right;" />
                    <span class="input-group-text" id="basic-addon2">%</span>
                  </div>
                </td>
                <td  :style="!showInfo.commission ? {visibility:'hidden'} : {}"  class="tdBottomless">
                 <div class="tdBorder rounded">
                  <img src="@/assets/ic_info_yellow.png" alt="icon-info"/>
                   <span>
                    Amount Paxel gets from each order (<b>in percentage %</b>). This is default/general comissions for newly registered seller
                    </span>
                    <font-awesome-icon icon="fa-solid fa-xmark" class="ms-auto" color="#FFB003" @click="handleHide('commission')"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="tdBottomless">
                  <div class="label">
                    <span>
                      Admin Fee Charged to Buyer
                    </span>
                    <img alt="info" class="info-icon" src="@/assets/ic_info.png" @click="handleShow('admin')"/>
                  </div>
                </td>
                <td class="tdBottomless">                  
                  <CustomInput
                      :isRupiah="true"
                      type="number"
                      placeholder="0"
                      :value="admin_fee"
                      @onChange="(value)=> admin_fee = value"
                      :maxlength="23"
                  />
                </td>
                <td :style="!showInfo.admin ? {visibility:'hidden'} : {}" class="tdBottomless">
                  <div class="tdBorder rounded">
                    <img src="@/assets/ic_info_yellow.png" alt="icon-info"/>
                    <span>
                      Amount Paxel gets from Buyer on each order (<b>in flat amount IDR</b>).
                    </span>
                    <font-awesome-icon icon="fa-solid fa-xmark" class="ms-auto" color="#FFB003" @click="handleHide('admin')"/>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

    </div>
    <div class="mt-1 d-flex justify-content-start">
      <button type="button" class="btn btn-danger text-white shadow-sm rounded" @click="submit" :class="admin_fee !== '' && default_comission !== '' ? '' : 'disabled'">
        SAVE CHANGES
      </button>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput.vue"

export default {
  components: {
    CustomInput
  },
  data() {
    return {
      default_comission: 0,
      admin_fee: 0,
      order_fee_setting: [],
      id: "",
      showInfo: {
        commission: true,
        admin: true
      }
    };
  },
  watch:{
    default_comission(val){
      if(val < 0) this.default_comission = 0
      if(val >= 100) this.default_comission = 100
    }
  },
  methods: {
    handleHide(key){
      this.showInfo[key] = false
    },
    handleShow(key){
      this.showInfo[key] = true
    },
    async submit() {
      try {
        const payload = {
          "order_fee_setting_id": this.id,
          "default_comission": this.default_comission,
          "admin_fee": this.admin_fee
        }
        await this.$store.dispatch("order_fee/updateOrderFeeSetting", payload)

        this.$router.push("/finance/sellers-commission");

      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    },
    async getOne() {
      try {
        let data = await this.$store.dispatch("order_fee/getOneOrderFeeSetting")
        this.order_fee_setting = data.data.data.OrderFeeSetting
        this.default_comission = this.order_fee_setting.default_comission
        this.admin_fee = this.order_fee_setting.admin_fee
        this.id = this.order_fee_setting.id

        console.log(this.order_fee_setting)
      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    },
    isNumber: (evt) => {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.getOne()
  },
};
</script>

<style scoped lang="scss">
.tdBottomless{
  border-bottom-width: 0px !important;
  vertical-align: middle;
  .label{
    display: flex;
    align-items: center;
    gap: 6px;
    img{
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
}
.tdBorder{
  border-color: inherit;
  border-style: solid;
  font-weight: normal !important;
  border: 1px solid #FFB003 !important;
  background-color: #FFE9B9;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 36px;
  padding: 3px 12px; 

  svg{
    cursor: pointer;
  }
}
</style>